import { defineComponent as _defineComponent } from 'vue'
import { computed, Component } from 'vue';
import { RailGlyphPosition, RailGlyphType, RailResponse } from '@/types/cms';

import GlyphT from './GlyphT.vue';
import GlyphG from './GlyphG.vue';
import GlyphLeftX from './GlyphLeftX.vue';
import GlyphRightX from './GlyphRightX.vue';
import GlyphGRotatedRight from './GlyphGRotatedRight.vue';
import GlyphCRotatedLeft from './GlyphCRotatedLeft.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'GlyphView',
  props: {
    rail: null
  },
  setup(__props: any) {

const props = __props as {
  rail: RailResponse;
};


const GLYPH_SCALE = 4;


const GLYPHS: Record<RailGlyphType, { component: Component; width: number; height: number }> = {
  T: { component: GlyphT, width: 304, height: 285 },
  G: { component: GlyphG, width: 192, height: 128 },
  LEFT_X: { component: GlyphLeftX, width: 85, height: 200 },
  RIGHT_X: { component: GlyphRightX, width: 85, height: 200 },
  G_ROTATED_RIGHT: { component: GlyphGRotatedRight, width: 88, height: 200 },
  C_ROTATED_LEFT: { component: GlyphCRotatedLeft, width: 144, height: 200 },
};

const DEFAULT_POSITION: RailGlyphPosition = 'TOP_MIDDLE';



const glyph = computed(() => {
  const type = props.rail.backgroundGlyph;
  if (!type) {
    return null;
  }

  return GLYPHS[type] ?? null;
});

const positionClass = computed(() => {
  const position = props.rail.backgroundGlyphPosition ?? DEFAULT_POSITION;
  return `at-${position.toLowerCase().replace(/_/g, '-')}`;
});

const glyphStyle = computed(() => {
  if (!glyph.value) {
    return undefined;
  }
  return {
    width: `${glyph.value.width * GLYPH_SCALE}px`,
    height: `${glyph.value.height * GLYPH_SCALE}px`,
    color: props.rail.backgroundGlyphColor ?? undefined,
  };
});


return { __sfc: true,GLYPH_SCALE, GLYPHS, DEFAULT_POSITION, props, glyph, positionClass, glyphStyle }
}

})